import React from 'react';
import { CheckIcon, MountainIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { assurances, checkoutUrl, productBrand, productEdition } from '../data/offer';
export function FinalCta() {
  return <section className="border-t border-slate-800 bg-slate-900/50 py-16 sm:py-20" aria-labelledby="final-title" data-id="element-58" data-mp="19g0bjea05oib">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-59" data-mp="15bsmth3jo8k3">
        <h2 id="final-title" className="text-balance text-3xl font-extrabold uppercase tracking-tight text-white sm:text-4xl" data-id="element-60" data-mp="1jcliw69hvbpb">
          <span className="inline-flex items-center gap-2" data-id="element-61" data-mp="1ed8xlpy9ucou">
            <MountainIcon className="h-8 w-8 shrink-0 text-orange-400" aria-hidden="true" data-id="element-62" data-mp="1t2onl3pzae3h" /> {productBrand}
          </span>
          <span className="mt-2 block text-xl font-extrabold uppercase tracking-[.16em] text-amber-400 sm:text-2xl" data-id="element-63" data-mp="1o3lg7cmizvsc">
            {productEdition}
          </span>
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-lg leading-relaxed text-slate-300" data-id="element-64" data-mp="1x4tcjp5hemjs">
          Creata per insegnanti di scienze e geografia della scuola secondaria.
        </p>

        <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-8 w-full sm:w-auto" data-id="element-65" data-mp="n7ywt3r1xmqj">
          Ottieni ora l&apos;Edizione Docenti
        </Button>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-slate-300" data-id="element-66" data-mp="x2h4ejzla2fm">
          {assurances.map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-67" data-mp="164qbezvnfdo9">
              <CheckIcon className="h-4 w-4 text-orange-400" aria-hidden="true" data-id="element-68" data-mp="162dv0r5jhbdb" /> {item}
            </li>)}
        </ul>
      </div>
    </section>;
}